import { render, staticRenderFns } from "./purchaseInvoiceTask.vue?vue&type=template&id=30fc10f5&scoped=true"
import script from "./purchaseInvoiceTask.vue?vue&type=script&lang=js"
export * from "./purchaseInvoiceTask.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "30fc10f5",
  null
  
)

export default component.exports